export const VENDOR_CHART_IS_ESSENTIAL = "has_search_position_perk"
